/**
 * @author salla.saishiva
 * @Date: 2023-09-14 11:30:49
 * @Last Modified by: salla.saishiva
 * @Last Modified time: 2023-09-14 16:30:49
*/

import React, { PureComponent } from 'react';
import { Card, Col, Row } from 'antd';
import { Container } from '../../../../components';
import { AppWrappperHOC } from '../../../Root/HOC';
import { StyledBoardDirectors } from '../StyledIPO';
import { BOARD_OF_DIRECTORS } from './constants';

const { Meta } = Card;

class BoardDirectors extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { BOARD_OF_DIRECTORS_OVERVIEW } = BOARD_OF_DIRECTORS;
    return (
      <StyledBoardDirectors>
        <Container>
          <Row type="flex" align="stretch" justify="start" gutter={[18, 18]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <h2 className="text-red">
                <b>Board of Directors</b>
              </h2>
            </Col>
            {BOARD_OF_DIRECTORS_OVERVIEW && BOARD_OF_DIRECTORS_OVERVIEW.map(({
              id,
              title,
              imgAlt,
              imgUrl,
              redirectLink,
              desgination,
            }) => (
              <Col key={id} xs={24} sm={24} md={6} lg={6} xl={6}>
                <a href={`/board-of-directors/${redirectLink}`}>
                  <Card
                    className="board-directors-card"
                    cover={
                      <img
                        alt={imgAlt}
                        src={imgUrl}
                      />
                    }
                  >
                    <Meta
                      title={title}
                      description={desgination}
                      className="bd-card-meta"
                    />
                  </Card>
                </a>
              </Col>
            ))}
          </Row>
        </Container>
      </StyledBoardDirectors>
    );
  }
}

const component = AppWrappperHOC(BoardDirectors);

export { BoardDirectors };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/BoardOfDirectors/index.jsx